import { parseJsonData } from "@frontend/services/helpers";
import { initDataBuilderTable } from "@frontend/group/modules/simple-table-builder/helpers";
import { unFocusObjects } from "@frontend/utils";
import { FIELD_TYPE_ADDITIONAL_HTML_TABLE } from "@frontend/constants/type-fields-of-template";

export async function drawAdditionalHtmlTable(params) {
  unFocusObjects();
  
  const { canvas, data } = params;
  
  canvas.getObjects().forEach((o) => {
    if (o.id.includes('add_html_')) {
      canvas.remove(o);
    }
  });

  if (data['add_html_tables']?.length) {
    let index = 0;
    
    for (const o of data['add_html_tables']) {
      const tableObject = parseJsonData(o, null);
      const table = initDataBuilderTable(tableObject);
      const options = parseJsonData(tableObject.fieldOptions, null);
      const tableOuterDimension = table.getOuterDimension();
      table.styles.setRules({
        'width': `${tableOuterDimension.width}px`,
        'height': `${tableOuterDimension.height}px`,
      });
      
      if (!options) {
        continue;
      }
      
      const blob = await table.toBlob();
      const reader = new FileReader();

      const currentIndex = index;
      index++;
      
      reader.readAsDataURL(blob);
      reader.onloadend = function () {
        const base64data = reader.result;
        
        fabric.Image.fromURL(base64data, function (image) {
          image.set({
            id: `add_html_table_${currentIndex}`,
            element_id: `add_html_table_${currentIndex}`,
            field_id: table.id,
            name: `Additional Table ${currentIndex + 1}`,
            left: options.X || 0,
            top: options.Y || 0,
            opacity: options.opacity || 1,
            fieldType: FIELD_TYPE_ADDITIONAL_HTML_TABLE,
            tableData: tableObject.fieldOptions,
            html_table_data: data['add_html_tables'],
            scaleX: options.ScaleX || 1,
            scaleY: options.ScaleY || 1,
            visible: data['add_html_tables_visible']?.[currentIndex] ?? true
          });

          canvas.add(image);
          canvas.renderAll();
        });
      };
    }
  }
}
